module.exports = __webpack_public_path__ + "static/media/bg_blue.66d1b338.svg";